import * as client from '@dashhudson/api-client/linkedin/client';

export const getLinkedinAccount = ({ brandId }: { brandId: number }, config: RequestInit = {}) =>
  client.getBrandsBrandIdAccountMe(brandId, config);

export const getLinkedinAccountAllBrands = (
  { brandIds }: { brandIds: number[] },
  config: RequestInit = {},
) => client.putBrandsAccounts({ brandIds }, config);
